import { render, staticRenderFns } from "./VisionMission.vue?vue&type=template&id=1852e3f2&scoped=true&"
import script from "./VisionMission.vue?vue&type=script&lang=js&"
export * from "./VisionMission.vue?vue&type=script&lang=js&"
import style0 from "./VisionMission.vue?vue&type=style&index=0&id=1852e3f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1852e3f2",
  null
  
)

export default component.exports